import ProtectedRoutePayment from './ProtectedRoutePayment'

export default ProtectedRoutePayment
